<template>
  <div class="contact">
    <div class="container">
      <h1 class="contact__title">Contact</h1>
      <div class="contact__content">
        <div class="contact__logo">
          <img
            class=""
            :src="require(`@/assets/logos/jorify_cg_white.svg`)"
            alt="Jorify logo"
          />
        </div>
        <div class="contact__text">
          For more information please don’t hesitate to contact me.
        </div>
        <div class="contact__email">
          <img src="@/assets/icons/mail.svg" alt="Mail" />
          jorifycg@gmail.com
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import store from "@/store.js";

export default {
  name: "contact",
  components: {},
  data() {
    return {
      about: store.contact,
    };
  },
};
</script>
<style scoped>
.contact {
  margin: 16px 0 0;
}

.contact__title {
  margin-left: 16px;
  font-family: "Saira Condensed Bold", sans-serif;
  font-weight: 700;
  font-size: 100px;
  line-height: 69px;
  color: var(--color-yellow);
  text-transform: uppercase;
}

.contact__content {
  background-color: var(--color-black);
  border-radius: 0 5px 5px 5px;
  color: white;
  padding: 32px;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.contact__logo {
  margin-bottom: 16px;
}

.contact__text {
  font-family: "Titillium Regular", sans-serif;
  font-size: 18px;
  font-weight: 400;
  margin-bottom: 48px;
}

.contact__email {
  display: flex;
  align-items: center;

  font-family: "Titillium Regular", sans-serif;
  font-size: 20px;
  font-weight: 700;
}

.contact__email img {
  margin-right: 24px;
}
</style>
